import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled, { css } from 'styled-components';
import { toast } from 'react-toastify';
import { getDashboard } from '../../modules/Dashboard';
import { LoadingSpinnerPage } from '../../components/atomic/Loaders/LoadingSpinner';
import * as dashboardText from '../../core/collections/dashboardTooltipText';

import MainCard from '../../components/molecule/ShortcutCards/MainCard';
import SecondCard from '../../components/molecule/ShortcutCards/SecondCard';
import SmallCard from '../../components/molecule/ShortcutCards/SmallCard';
import PromotionalCode from '../../components/molecule/PromotionalCode';
import Card from '@material-ui/core/Card';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`
const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  // width: 750px;
  margin: 100px auto;
`
const ButtonGroup = styled(Card)`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 270px;
  margin: 6px;
  background: white;
  ${props => {
    if (props.top) {
        return css`
          margin-top: auto;
        `
    }
  }}
`
const SecondCardStyled = styled(SecondCard)`
  flex: 1;
  // margin: 6px;
  max-height: 50px;
  min-height: 50px;
`
const SmallCardStyled = styled(SmallCard)`
  flex: 1;
  max-height: 60px;
  min-height: 60px;
  border-top: 1px solid #ccc;
  ${props => {
    if (props.middle) {
        return css`
          border-bottom: 1px solid #ccc;
        `
    }
  }}
`
const MainCardStyled = styled(MainCard)`
  flex: 1;
`
const TopWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

class DashboardPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    const { getDashboard } = this.props;
    try {
      await getDashboard();
    } catch(e) {
      console.log('component: ',this,e.message);
      toast.error(e.message);
    }
  }

  getCards = (data) => {
    const { authState, history } = this.props;
    const { trainer_relationship } = authState.userData ? authState.userData : {};

    if(data) {
      const {
        channel,
        complete_exercises,
        incomplete_exercises,
        published_classes,
        draft_classes,
        unlabeled_exercise_videos,
      } = data;

      return (
        <ButtonsWrapper>
          <TopWrapper>
          { trainer_relationship === "trainer" &&
            <ButtonGroup top={"true"}>
              <SecondCardStyled label="EXERCISES" icon="fitness_center"/>
              <SmallCardStyled
                label="COMPLETE"
                onClick={() => history.push('/exercises')}
                TooltipText={dashboardText.Exercise}
                count={complete_exercises}/>
              <SmallCardStyled
                label="INCOMPLETE"
                onClick={() => history.push('/exercises')}
                TooltipText={dashboardText.Incomplete_Exercises}
                count={incomplete_exercises}/>
              <SmallCardStyled
                label="DEMOS"
                TooltipText={dashboardText.Demos}
                onClick={() => history.push('/exercises/demos')}
                count={unlabeled_exercise_videos}/>
            </ButtonGroup>
          }
            <ButtonGroup>
              <MainCardStyled image={channel.channel_image.url !== '' ? channel.channel_image.url : undefined}/>
              <SmallCardStyled
                label="CHANNEL"
                TooltipText={dashboardText.Channel}
                onClick={() => history.push('/channel')}/>
              <SmallCardStyled
                label="SETTINGS"
                onClick={() => history.push('/settings')}/>
              { trainer_relationship === "trainer" &&
                <SmallCardStyled
                  label="Empty" />
              }
            </ButtonGroup>
          { trainer_relationship === "trainer" &&
            <ButtonGroup top={"true"}>
              <SecondCardStyled label="CLASSES" icon="school"/>
              <SmallCardStyled
                label="PUBLISHED"
                TooltipText={dashboardText.Published_Classes}
                onClick={() => history.push('/classes')}
                count={published_classes}/>
              <SmallCardStyled
                label="UNPUBLISHED"
                onClick={() => history.push('/classes/drafts')}
                TooltipText={dashboardText.Unpublished_Classes}
                count={draft_classes}/>
              <SmallCardStyled
                label="Empty" />
            </ButtonGroup>
          }
          </TopWrapper>
        </ButtonsWrapper>
      )
    } else {
      return null;
    }
  }

  render() {
    const { dashboardState } = this.props;

    return (
      <Container>
        {
          dashboardState.isLoading ? (
            <LoadingSpinnerPage/>
          ) : (
            <React.Fragment>
              <PromotionalCode value={dashboardState.data} header="Live Channel" subheader="Channel is live when the taks below are complete." />
              {this.getCards(dashboardState.data)}
            </React.Fragment>
          )
        }
      </Container>
    );
  }
}


DashboardPage.propTypes = {

};

DashboardPage.defaultProps = {

};

function mapStateToProps(state) {
  return {
    resourceState: state.resourceState,
    authState: state.authState,
    dashboardState: state.dashboardState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getDashboard: getDashboard,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);
